import Header from "../../../sections/Header/Header";
import React from "react";
import Trial from "../../../sections/Bookfreetrial/Trial";
import Footer from "../../../sections/Footer/Footer";
import TitleBgCoursesBQR from "../../../sections/TitleBgCourses/TitlepicCourses/TitleBgCoursesBQR/TitleBgCoursesBQR";
import CoursesPicContBQR from "../../../sections/TitleBgCourses/CoursesPicContBQR/CoursesPicContBQR";

const CoursesBQR =()=>{
    return(
        <div>
            <Header/>
            <TitleBgCoursesBQR/>
            <CoursesPicContBQR/>
            <Trial/>
            <Footer/>
        </div>
    )
}
export default CoursesBQR;